export default "../../src/img/patterns/cover.jpg";